import { useContext as s } from "react";
import { TranslationContext as u } from "../provider/translation-provider.js";
import { c } from "../crc32-LCGpXEbE.js";
import { u as l } from "../useTranslation-De5US25M.js";
import "../jsx-runtime-ClgrxkDP.js";
import "../constants-BZU6eCHC.js";
import "../i18nInstance-D20fwFYr.js";
function T() {
  const t = s(u), { ready: r, t: o, i18n: a } = l(), e = (n, i = {}) => o(c.str(n).toString(), { defaultValue: n, ...i });
  if (!t)
    throw new Error(
      "useTranslation has to be used within <TranslationContext.Provider>"
    );
  return {
    ready: r,
    localize: e,
    instance: a,
    switchLanguage: t.switchLanguage,
    currentLang: t.currentLang
  };
}
export {
  T as default
};
